import React from 'react';
import { Link } from '@mui/material';
import { BLUE_500 } from '../../constants/Colors';

interface BakeasyLinkButtonProps {
  label: string;
  disabled?: boolean;
  fullWidth?: boolean;
  variant?: any;
  style?: React.CSSProperties;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function BakeasyLinkButton(props: BakeasyLinkButtonProps) {
  return (
    <Link
      component="button"
      color={BLUE_500}
      borderColor={BLUE_500}
      onClick={props?.onClick}
      style={props?.style ?? { fontWeight: 'bold', textAlign: 'left' }}
    >
      {/* {props?.label} */}
      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {props?.label}
      </div>
    </Link>
  );
}

export default BakeasyLinkButton;
